module.exports = "/_next/static/images/al-bfd0a0ce61206943fff472f113d33b06.svg";